import React from "react";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductSection from "../customer/Components/Home/HomeProductSection";
import Advertisement from "../customer/Components/Advertisement/Advertisement";
import VideoFeed from "../customer/Components/VideoFeed/VideoFeed";
import MarketingClaims from "../customer/Components/MarketingClaims/MarketingClaims";

const Homepage = () => {
  return (
    <div>
      <HomeCarousel images={homeCarouselData} />
      <Advertisement />
      <VideoFeed section={"SHOP THE REELS"} />
      <div className="space-y-10 py-20">
        <HomeProductSection section={"SHERVANI"} query="shervani" view_all />
        <HomeProductSection section={"KOTI"} query="koti" view_all />
        <HomeProductSection section={"ETHENIC"} query="ethenic" view_all />
        <HomeProductSection section={"SAFA"} query="safa" view_all />
        <MarketingClaims />
      </div>
    </div>
  );
};

export default Homepage;
